import {useMergeboxStatusCalculator} from '@github-ui/mergebox/use-mergebox-status-calculator'
import {EMPTY_CHANNELS} from '@github-ui/mergebox/use-mergeability-live-updates'
import {useMergeStatusButtonData} from '../../../../hooks/use-merge-status-button-data'
import {useLayoutRouteData} from '../../../../page-data/loaders/use-layout-route-data'

export type MergeBoxPullRequest = ReturnType<typeof useMergeboxStatusCalculator>['pullRequest']

/**
 * Wraps the merge-status calculator pipeline (which also wires up the relevant
 * live updates) and surfaces the status checks, rollup, pull request payload and
 * checks section that the individual For You items derive their state from.
 *
 * Returns `null` when there is no validated merge data, in which case consumers
 * should early return so the item is not registered as visible.
 */
export function useValidatedChecksData() {
  const {pullRequest, mergeStatusButtonData} = useLayoutRouteData()
  const validatedMergeData = useMergeStatusButtonData(pullRequest.state, mergeStatusButtonData)

  // hack: the calculator hook was not built with undefined/null in mind
  const headSha = validatedMergeData?.headSha ?? ''
  const channels = validatedMergeData?.channels ?? EMPTY_CHANNELS

  const {
    calculator,
    pullRequest: mergeBoxPullRequest,
    statusChecksData,
  } = useMergeboxStatusCalculator({headSha, channels})

  if (!validatedMergeData) return null

  return {
    mergeBoxPullRequest,
    statusChecks: statusChecksData.statusChecks,
    statusRollup: statusChecksData.statusRollup,
    checksSection: calculator.sections.ChecksSection,
  }
}
